import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReferenceDataLabels, ReferenceDataService } from '../../../public_api';
import { RomeUiLoaderService } from '../../services/rome-ui-loader.service';

@Component({
  selector: 'boi-rome-ui-loader',
  templateUrl: './rome-ui-loader.component.html',
  styleUrls: ['./rome-ui-loader.component.scss']
})
export class RomeUiLoaderComponent implements OnDestroy {
  private readonly destroySubject$ = new Subject();
  public showLoading: boolean;
  public progressBarHeaderText;
  public progressBarBodyText;

  constructor(
    private readonly romeUiLoaderService: RomeUiLoaderService,
    private readonly referenceDataService: ReferenceDataService
  ) {
    this.romeUiLoaderService.showLoading$.pipe(takeUntil(this.destroySubject$)).subscribe((showLoading) => {
      this.progressBarHeaderText = this.romeUiLoaderService.customRomeEndpointConfigItem?.headerText
        ? this.referenceDataService.getLocalizeLabel(this.romeUiLoaderService.customRomeEndpointConfigItem.headerText)
        : this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.ProgressBarDefaultHeader);

      this.progressBarBodyText = this.romeUiLoaderService.customRomeEndpointConfigItem?.bodyText
        ? this.referenceDataService.getLocalizeLabel(this.romeUiLoaderService.customRomeEndpointConfigItem.bodyText)
        : this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.ProgressBarDefaultBody);

      this.showLoading = showLoading;
    });
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
